'use client';

import { NumericFormat } from 'react-number-format';
import TextField, { TextFieldProps } from '../../inputs/TextField/TextField';
import { ComponentPropsWithoutRef } from 'react';
import { DollarSign } from '../../../icons';

type CurrencyFieldProps = TextFieldProps &
  ComponentPropsWithoutRef<typeof NumericFormat> & {
    currencySymbol?: string;
  };

export default function CurrencyField({
  fieldPrefix = <DollarSign />,
  ...props
}: CurrencyFieldProps) {
  return (
    <NumericFormat
      {...props}
      fieldPrefix={fieldPrefix}
      thousandSeparator
      customInput={TextField}
      decimalScale={2}
    />
  );
}
